import React from 'react';
import WorkflowTemplate from '../../components/WorkflowTemplate';
import { LEAD_STAGES } from 'models/Lead';

const WorkflowEnquirePage: React.FC = () => (
  <WorkflowTemplate page={LEAD_STAGES.ENQUIRE} />
);

export default WorkflowEnquirePage;
